'use client';

import { Mail, Phone, MapPin } from 'lucide-react';
import Link from 'next/link';
import { COMPANY_INFO, getFullAddress } from '@/config/company';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-12 lg:py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-10 lg:gap-12 mb-8 sm:mb-10 lg:mb-12">

          <div className="fade-in sm:col-span-2 lg:col-span-1">
            <h3 className="text-xl sm:text-2xl font-bold text-[#23994F] mb-3 sm:mb-4">Verphone</h3>
            <p className="text-sm sm:text-base text-gray-400 mb-4 sm:mb-6">
              Les meilleurs téléphones reconditionnés avec garantie 12 mois.
            </p>
            <div className="space-y-2 sm:space-y-3">
              <a href={`tel:${COMPANY_INFO.contact.phone}`} className="flex items-center gap-2 sm:gap-3 text-gray-400 hover:text-[#23994F] transition-colors min-h-11 text-sm sm:text-base">
                <Phone size={16} className="sm:w-[18px] sm:h-[18px] shrink-0" />
                <span>{COMPANY_INFO.contact.phone}</span>
              </a>
              <a href={`mailto:${COMPANY_INFO.contact.email}`} className="flex items-center gap-2 sm:gap-3 text-gray-400 hover:text-[#23994F] transition-colors min-h-11 text-sm sm:text-base break-all">
                <Mail size={16} className="sm:w-[18px] sm:h-[18px] shrink-0" />
                <span>{COMPANY_INFO.contact.email}</span>
              </a>
              <div className="flex items-center gap-2 sm:gap-3 text-gray-400 hover:text-[#23994F] transition-colors min-h-11 text-sm sm:text-base">
                <MapPin size={16} className="sm:w-[18px] sm:h-[18px] shrink-0" />
                <span>{getFullAddress()}</span>
              </div>
            </div>
          </div>


          <div className="fade-in" style={{ animationDelay: '0.1s' }}>
            <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6">Produits</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  href="/products?category=SMARTPHONE"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Téléphones
                </Link>
              </li>
              <li>
                <Link
                  href="/products?category=TABLET"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Tablettes
                </Link>
              </li>
              <li>
                <Link
                  href="/products?category=ACCESSORIES"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Accessoires
                </Link>
              </li>
              <li>
                <Link
                  href="/services"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Services
                </Link>
              </li>
            </ul>
          </div>


          <div className="fade-in" style={{ animationDelay: '0.2s' }}>
            <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6">Entreprise</h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link
                  href="/about"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  À propos
                </Link>
              </li>
              <li>
                <Link
                  href="/services"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Nos services
                </Link>
              </li>
              <li>
                <Link
                  href="/privacy-policy"
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Confidentialité
                </Link>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY_INFO.contact.email}`}
                  className="text-gray-400 hover:text-[#23994F] transition-colors font-medium text-sm sm:text-base inline-block min-h-11 flex items-center"
                >
                  Nous contacter
                </a>
              </li>
            </ul>
          </div>


          <div className="fade-in sm:col-span-2 lg:col-span-1" style={{ animationDelay: '0.3s' }}>
            <h4 className="font-bold text-base sm:text-lg mb-4 sm:mb-6">Newsletter</h4>
            <p className="text-sm sm:text-base text-gray-400 mb-3 sm:mb-4">
              Recevez nos meilleures offres par email
            </p>
            <div className="flex flex-col sm:flex-row gap-2 w-full">
              <input
                type="email"
                placeholder="Bientôt disponible..."
                disabled
                className="flex-1 min-w-0 px-3 sm:px-4 py-2 min-h-11 rounded-lg bg-gray-800 text-gray-500 text-sm sm:text-base border border-gray-700 cursor-not-allowed"
              />
              <button
                disabled
                className="px-4 py-2 min-h-11 bg-gray-700 text-gray-500 text-sm sm:text-base rounded-lg cursor-not-allowed font-semibold shrink-0"
              >
                S'abonner
              </button>
            </div>
          </div>
        </div>

        {/* DIVIDER */}
        <div className="border-t border-gray-800 pt-6 sm:pt-8">
          {/* RELAY POINTS */}
          <div className="mb-6 sm:mb-8 pb-6 sm:pb-8 border-b border-gray-800" suppressHydrationWarning>
            <h4 className="font-bold text-base sm:text-lg mb-3 sm:mb-4">Points de retrait disponibles</h4>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
              <a
                href="https://www.chronopost.fr/fr"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQLkDh3fk6ey4mjXbelKo-xdaOEqBXhRe7P7Q&s"
                    alt="Pickup Chronopost"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">Pickup Chronopost</p>
                  <p className="text-gray-400 text-xs">Point relais</p>
                </div>
              </a>
              <a
                href="https://www.dpd.com/fr/fr/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1.5">
                  <img
                    src="https://cdn.shopify.com/app-store/listing_images/f1636f1bb92febfb4469b13a97849de8/icon/CPTarLP0lu8CEAE=.png"
                    alt="DPD"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">DPD</p>
                  <p className="text-gray-400 text-xs">Relais pickup</p>
                </div>
              </a>
              <a
                href="https://www.laposte.fr/colissimo"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1.5">
                  <img
                    src="https://cdn.shopify.com/app-store/listing_images/6b1969a70f0f38f4f0b655d3b1b1f9fb/icon/CKjWxJGB1vsCEAE=.png"
                    alt="Colissimo"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">Colissimo</p>
                  <p className="text-gray-400 text-xs">La Poste</p>
                </div>
              </a>
              <a
                href="https://www.ups.com/fr/fr/Home.page"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1.5">
                  <img
                    src="https://about.ups.com/content/dam/upsstories/images/newsroom/statements/ups-statement-on-u-s--driver-voluntary-program/UPSstatement-logo-1023x960.jpg"
                    alt="UPS"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">UPS</p>
                  <p className="text-gray-400 text-xs">Access Point</p>
                </div>
              </a>
              <a
                href="https://www.mondialrelay.fr/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1.5">
                  <img
                    src="https://cdn.shopify.com/app-store/listing_images/1ce5021cbfb5eff03e8af1d8bbfed6b9/icon/COaP1rGF8_kCEAE=.png"
                    alt="Mondial Relay"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">Mondial Relay</p>
                  <p className="text-gray-400 text-xs">Point relais</p>
                </div>
              </a>
              <a
                href="https://vinted.fr/go"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 sm:gap-3 hover:bg-gray-800/50 p-2 rounded-lg transition-colors"
              >
                <div className="w-10 h-10 sm:w-11 sm:h-11 rounded-lg bg-white/90 flex items-center justify-center shrink-0 p-1.5">
                  <img
                    src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThODmV0QRONIToZ9jea-eFjiLgK0o-5Tk8Ww&s"
                    alt="Vinted Go"
                    width="32"
                    height="32"
                    className="object-contain rounded"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="font-semibold text-white text-xs sm:text-sm">Vinted Go</p>
                  <p className="text-gray-400 text-xs">Retrait sécurisé</p>
                </div>
              </a>
            </div>
          </div>

          <div className="flex flex-col sm:grid sm:grid-cols-2 gap-4 sm:gap-4">
            {/* LEGAL */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-6 text-gray-400 text-xs sm:text-sm">
              <Link href="/privacy-policy" className="hover:text-[#23994F] transition-colors min-h-11 flex items-center">
                Politique de confidentialité
              </Link>
              <Link href="/terms-of-use" className="hover:text-[#23994F] transition-colors min-h-11 flex items-center">
                Conditions d'utilisation
              </Link>
              <Link href="/cookie-policy" className="hover:text-[#23994F] transition-colors min-h-11 flex items-center">
                Cookies
              </Link>
            </div>


            <div className="text-gray-400 text-xs sm:text-sm sm:text-right pt-4 sm:pt-0 border-t sm:border-t-0 border-gray-800">
              © {currentYear} Verphone. Tous droits réservés.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
